import { DeleteFilled } from '@ant-design/icons';
import { Form, message, Popconfirm, Tag, Tooltip } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
  deleteLoanType,
  DeleteLoanTypePayload,
  getLoanTypeList,
  LoanTypeData,
  LoanTypePagedList,
  LoanTypePayload,
} from 'api/master';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

let payPagedList: LoanTypePagedList = {
  data: [],
  noOfRecords: 0,
};

type Props = {
  filter: LoanTypePayload;
  onSubmit: (values: LoanTypePayload) => Promise<void>;
};

const filterPayload: LoanTypePayload = {};
const LoanTypeList = ({ filter }: Props) => {
  const navigate = useNavigate();
  const [form] = Form.useForm<LoanTypePayload>();
  const [pagedList, setPagedList] = useState(payPagedList);
  const [_isLoading, setIsLoading] = useState(false);
  const [isFilter, setFilter] = useState(false);
  const [deleted, isDeleted] = useState(false);
  // const [_isReset, setReset] = useState(false);
  const [_isfilter, setfilter] = useState(filterPayload);
  filter.Username = sessionStorage.getItem('user')?.toString();
  filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();

  useEffect(() => {
    setIsLoading(false);
    setPagedList(payPagedList);
    if (filter.LoanType != null || filter.PaymentPurpose != null) {
      if (deleted == true) {
        setFilter(false);
      } else {
        setFilter(true);
      }
      getLoanTypeList(filter)
        .then((res) => {
          debugger;
          setPagedList(res.data);
          // message.success('Success');
        })
        .finally(() => {
          form.resetFields();
          isDeleted(false);
          setIsLoading(true);
        });
    }
  }, [form, filter]);

  const handleDelete = (_s: any) => {
    setIsLoading(true);
    const a: DeleteLoanTypePayload = {
      SourceApplicationName: _s.sourceApplicationName,
      LoanType: _s.LoanType,
    };
    deleteLoanType(a)
      .then((res) => {
        debugger;
        if (res.responseCode == '200' && res.message == 'Loan Type Deleted!') {
          message.success('LoanType Deleted!');
        }
        if (res.responseCode == '200' && res.message == 'Loan Type Already Deleted!') {
          message.warn('Loan Type Already Deleted!');
        }
        if (res.responseCode != '200') {
          message.error('Some Error Occured');
        }
      })
      .finally(() => {
        form.resetFields();
        setFilter(true);
        isDeleted(true);
        let updatedFilter = { ...filter };
        updatedFilter = filterPayload;
        setfilter(updatedFilter);
        navigate('/master/loan-type');
      });
  };

  const columns: ColumnsType<LoanTypeData> = [
    {
      key: 'LoanType',
      title: 'Loan Type',
      dataIndex: 'LoanType',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
      className: '',
    },
    {
      key: 'PaymentPurposeList',
      title: 'Payment Purpose',
      dataIndex: 'PaymentPurposeList',
      ellipsis: true,
      render: (_, { PaymentPurposeList }) => (
        <>
          {PaymentPurposeList.map((ppl: any) => {
            return (
              <Tooltip placement="topLeft" title={ppl}>
                <Tag>{ppl}</Tag>
              </Tooltip>
            );
          })}
          {/* <Tooltip placement="topLeft" title={ppl}>
                    {ppl}
                </Tooltip> */}
        </>
      ),
    },
    {
      key: 'Action',
      title: 'Action',
      dataIndex: 'action',
      ellipsis: true,
      render: (_, _record) => (
        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(_record)}>
          <a>
            <DeleteFilled style={{ fontSize: '16px', marginLeft: '50px' }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    setIsLoading(false);

    filter.Username = sessionStorage.getItem('user')?.toString();
    filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();

    filter.PageNo = _pagination.current;
    filter.PageSize = _pagination.pageSize;
    getLoanTypeList(filter).then((res) => {
      setPagedList(res.data);
      setIsLoading(true);
    });
  };

  const maxWidthPerCell = 1000;

  const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <>
      {isFilter ? (
        <Table
          dataSource={dataTable.source}
          columns={dataTable.columns}
          rowKey={rowKey}
          scroll={{ x: dataTable.tableWidth + 400, y: tableHeight }}
          pagination={{
            pageSize: 10,
            total: pagedList.noOfRecords,
            current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
          }}
          onChange={handleChange}
        />
      ) : null}
      ;
    </>
  );
};
export default LoanTypeList;
